import { isEntityUri } from '#app/lib/boolean_tests'
import { newError } from '#app/lib/error'
import { isEntityType } from '#entities/lib/types/entities_types'
import type { EntityType, EntityUri } from '#server/types/entity'

export function assertEntityType (type: unknown): asserts type is EntityType {
  if (!isEntityType(type)) {
    throw newError(`invalid entity type: ${type}`, 400, { type })
  }
}

export function assertEntityUri (uri: unknown): asserts uri is EntityUri {
  if (!isEntityUri(uri)) {
    throw newError(`invalid entity uri: ${uri}`, 400, { uri })
  }
}
